import { Modal, Divider } from 'antd';
import { isBrowser, isMobile, isAndroid, isIOS } from 'react-device-detect';

import { isDashboardArabic } from 'utils/intl-wrapper';

import BRButton from 'components/BRButton/BRButton';
import { fmt } from 'components/IntlWrapper/IntlWrapper';
import { BannerContent } from 'components/Banner/Banner';

import { ReactComponent as Info } from 'assets/bosta-icons/Info-Circle.svg';

import './PopupGuideModal.less';

const PopupGuideModal = ({ close, ...props }) => {
  const STEPS = {
    WEB: [
      { id: 1, text: 'chats_plugins.popup_guide.web.first' },
      { id: 2, text: 'chats_plugins.popup_guide.web.second' },
      { id: 3, text: 'chats_plugins.popup_guide.web.third' }
    ],
    IOS: [
      { id: 1, text: 'chats_plugins.popup_guide.ios.first' },
      { id: 2, text: 'chats_plugins.popup_guide.ios.second' },
      { id: 3, text: 'chats_plugins.popup_guide.ios.third' },
      { id: 4, text: 'chats_plugins.popup_guide.ios.fourth' }
    ],
    ANDROID: [
      { id: 1, text: 'chats_plugins.popup_guide.android.first' },
      { id: 2, text: 'chats_plugins.popup_guide.android.second' },
      { id: 3, text: 'chats_plugins.popup_guide.android.third' },
      { id: 4, text: 'chats_plugins.popup_guide.android.fourth' },
      { id: 5, text: 'chats_plugins.popup_guide.android.fifth' }
    ]
  };

  const NOTES = { ANDROID: 'chats_plugins.popup_guide.android.note' };

  const BANNERS = { ANDROID: true, IOS: true, WEB: false };
  const VIDEO = { ANDROID: false, IOS: false, WEB: true };

  const LEARN_MORE_LINKS = {
    EN: 'https://sllr.freshdesk.com/en/support/solutions/articles/36000528877',
    AR: 'https://sllr.freshdesk.com/ar/support/solutions/articles/36000528877'
  };

  const deviceName = isBrowser
    ? 'WEB'
    : isMobile && isAndroid
    ? 'ANDROID'
    : 'IOS';

  const handleCloseModal = () => {
    close();
  };

  const handleLearnMore = () => {
    window.open(
      LEARN_MORE_LINKS[isDashboardArabic() ? 'AR' : 'EN'],
      '_blank',
      'noopener,noreferrer'
    );
  };

  return (
    <Modal
      {...props}
      footer={
        <BRButton
          label={fmt({
            id: `common.done`
          })}
          type="primary"
          onClick={handleCloseModal}
        />
      }
      onCancel={close}
      maskClosable={false}
      width={null}
      wrapClassName="br-chat-popup-guide-modal"
      title={fmt({
        id: `chats_plugins.chats_page.popup_action`
      })}
    >
      <div className="br-chat-popup-guide-modal__content">
        {VIDEO[deviceName] && (
          <video controls width="400">
            <source
              src="https://storage.googleapis.com/bosta-fe/Allow%20pop-ups%20video.mov"
              type="video/mp4"
            />
          </video>
        )}

        <span className="body-medium">
          {fmt({
            id: `chats_plugins.popup_guide.${deviceName.toLowerCase()}.title`
          })}
        </span>

        <div className="br-chat-popup-guide-modal__steps">
          {STEPS[deviceName].map(({ id, text }) => {
            return (
              <>
                <span id={id}>
                  {fmt(
                    {
                      id: text
                    },
                    {
                      TextDiv: (children) => (
                        <div className="body-medium">{children}</div>
                      )
                    }
                  )}
                </span>
                {id < STEPS[deviceName].length && <Divider />}
              </>
            );
          })}
        </div>

        {NOTES[deviceName] && (
          <span>
            {fmt({
              id: NOTES[deviceName]
            })}
          </span>
        )}

        {BANNERS[deviceName] && (
          <BannerContent
            title={fmt({
              id: `chats_plugins.popup_guide.help`
            })}
            type="info"
            icon={<Info />}
            buttonText={fmt({
              id: `chats_plugins.popup_guide.check_this`
            })}
            buttonProps={{
              onClick: handleLearnMore,
              type: 'link-color',
              className: 'button'
            }}
          />
        )}
      </div>
    </Modal>
  );
};

export default PopupGuideModal;
